export default function () {
  this.route('proxyviews-benchmarks', { path: '/benchmarks' });
  this.route('proxyviews-benchmarks-compare', { path: '/benchmarks/compare' });

  this.route('adminPlugins', { path: '/admin/plugins' }, function () {
    this.route('proxyviews-benchmarks', { path: '/proxyviews-benchmarks' });
  });
}
